import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import LandingPage from "../Pages/LandingPage";
import Login from "../Pages/Login";
import Invitations from "../Components/NavComponents/Cards/Invitations";
import BuyGifts from "../Components/NavComponents/Gifts/BuyGifts";
import CakesChochlate from "../Components/NavComponents/Gifts/CakesChochlate";
import Banquet from "../Components/NavComponents/Plan/Banquet";
import EventManager from "../Components/NavComponents/Plan/EventManager";
import FinanceEvents from "../Components/NavComponents/Plan/FinanceEvents";
import PlanEvents from "../Components/NavComponents/Plan/PlanEvents";
import PlantingCares from "../Components/NavComponents/Planting/PlantingCares";
import PotsPlants from "../Components/NavComponents/Planting/PotsPlants";
import AboutsUs from "../Components/NavComponents/AboutsUs";
import GreetingCard from "../Components/NavComponents/Cards/GreetingCard";
import UpdateProfile from "../Components/Profile/UpdateProfile";
import MyProfile from "../Components/Profile/MyProfile";
import Orders from "../Pages/Orders";
import Events from "../Pages/Events";
import GiftDiaries from "../Pages/GiftDiaries";
import Eshagun from "../Pages/Eshagun";
import Canvas from "../Pages/Canvas";
import PlantsLanding from "../Ecommerce/PlantsLanding";
import CreateEvent from "../Components/Home/Events/CreateEvent";
import AllCardData from "../Components/Home/NewDesign/Cards/AllCardData";
import AllProductData from "../Components/Home/NewDesign/Products/AllProductData";
import ProductDetails from "../Components/Home/NewDesign/Products/SingleProduct/ProductDetails";
import CustomizeCard from "../Components/Home/NewDesign/Cards/CustomizeCard";
import MyReminders from "../Components/Home/NewDesign/MyReminders";
import AiPowerGifts from "../Components/Home/AiPowerGifts";
import AllGreetings from "../Components/Home/NewDesign/Cards/AllGreetings";
import CreateInvitationDetail from "../Pages/panels/CreateInvitationDetail";
import AllInvitaions from "../Components/Home/NewDesign/Cards/AllInvitaions";
import InspirationDash from "../Components/NavComponents/SuggestGifts/InspirationDash";
import MyGroups from "../Pages/MyGroups";
import DetachImageCanvas from "../Pages/panels/DetachImageCanvas";
import AllHomeDecor from "../Components/NavComponents/Gifts/AllHomeDecor";
import AllPots from "../Components/NavComponents/Gifts/AllPots";
import ShareCardsPage from "../Components/Home/NewDesign/Cards/ShareCardsPage";
import PhotoFrames from "../Components/Home/NewDesign/Frames/PhotoFrames";
import AddToCart from "../Components/Cart/AddToCart";
import PlaceOrder from "../Components/Cart/PlaceOrder";
import OrderDetails from "../Components/Cart/OrderDetails";
import CorporateGifting from "../Components/NavComponents/Gifts/CorporateGifting";
import Blogs from "../Components/NavComponents/KnowUs/Blogs";
import Uploads from "../Pages/CanvasPages/Uploads";
import Panel from "../Pages/panels/Panel";
import ComingSoon from "../Components/ComingSoon";
import CustomizeInvitation from "../Components/Home/NewDesign/Cards/CustomizeInvitation";
import TryPlus from "../Pages/panels/TryPlus";
import NextRsvp from "../Pages/panels/NextRsvp";
import DisplayInvitationCard from "../Pages/panels/DisplayInvitationCard";
import AcceptInvitation from "../Pages/panels/AcceptInvitation";
import InspirationCategory from "../Components/NavComponents/SuggestGifts/InspirationCategory";
import PrivacyPolicy from "../Pages/FooterPages/PrivacyPolicy";
import HelpCenter from "../Pages/FooterPages/HelpCenter";
import Refund from "../Pages/FooterPages/Refund";
import ShippingNdelivery from "../Pages/FooterPages/ShippingNdelivery";
import TermOfUse from "../Pages/FooterPages/TermOfUse";
import { BASE_URL_USER } from "../Redux/App/action";
import jwt_decode from "jwt-decode";
import axios from "axios";
import GreetingsSubCat from "../Components/Home/NewDesign/CardsSubCat/GreetingsSubCat";
import InvitationSubCat from "../Components/Home/NewDesign/CardsSubCat/InvitationSubCat";
import SpicePlant from "../Ecommerce/Shop/PlantPages/SpicePlant";
import OutdoorPlant from "../Ecommerce/Shop/PlantPages/OutdoorPlant";
import IndoorPlant from "../Ecommerce/Shop/PlantPages/IndoorPlant";
import FruitPlant from "../Ecommerce/Shop/PlantPages/FruitPlant";
import Products from "../Components/products/Products";
import CartItems from "../Components/CartData/CartItems";
import PageNotFound from "../Pages/PageNotFound";
import AllTrendingProducts from "../Components/Home/NewDesign/Products/AllTrendingProducts";
import ContactUs from "../Pages/ContactUs/ContactUs";
// import AllWishlist from "../Pages/Wishlist/AllWishlist";

const PrivateRoute = ({ element, path }) => {
  const { _id, _token, _eventid } = useParams();

  const getNewToken = async (isAuthenticated) => {
    try {
      const response = await axios.get(`${BASE_URL_USER}/public-api/v1/token`, {
        headers: {
          token: `Bearer ${localStorage.getItem("refresh")}`,
        },
      });

      if (response.status === 200) {
        localStorage.setItem(
          "token",
          response.data.payload.token.accessToken.token
        );
        isAuthenticated = true;
      } else {
        localStorage.clear();
        isAuthenticated = false;
      }
    } catch (error) {
      console.error("Error signing in:", error);
    }
  };

  let isAuthenticated = false;
  if (path === `/canvas/:_id/:_token/:_eventid`) {
    if (_token) {
      localStorage.setItem("refresh", _token);
      localStorage.setItem("token", _token);
      getNewToken(isAuthenticated);
    }
  }
  const token = localStorage.getItem("token");
  const refresh = localStorage.getItem("refresh");

  let decodedAccessToken;
  let decodedRefreshToken;

  try {
    decodedAccessToken = jwt_decode(token);
    decodedRefreshToken = jwt_decode(refresh);
    const currentUnixTimestamp = Math.floor(Date.now() / 1000);
    isAuthenticated = true;
    if (currentUnixTimestamp > decodedAccessToken.exp) {
      getNewToken(isAuthenticated);
    }
    if (currentUnixTimestamp > decodedRefreshToken.exp) {
      localStorage.clear();
      isAuthenticated = false;
    }
  } catch (error) {
    console.error("Token decoding or expiration check failed:", error);
  }

  if (isAuthenticated) {
    localStorage.setItem("user", true);
  }

  return isAuthenticated ? (
    element
  ) : (
    <Navigate to="/authenticate" replace state={{ from: path }} />
  );
};

let isLogin = false;
let token = localStorage.getItem("refresh");
if (token) {
  let decodedRefreshToken = jwt_decode(token);
  if (decodedRefreshToken) {
    const currentUnixTimestamp = Math.floor(Date.now() / 1000);
    if (currentUnixTimestamp < decodedRefreshToken.exp) {
      isLogin = true;
    }
  }
}

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/authenticate"
        element={isLogin ? <Navigate to="/" /> : <Login />}
      />
      <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
      <Route path="/helpCenter" element={<HelpCenter />} />
      <Route path="/aiPowerGifts" element={<AiPowerGifts />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/CardPage" element={<AllCardData />} />
      <Route path="/trending-products" element={<AllTrendingProducts />} />
      <Route
        path="/productPage"
        element={<AllProductData ProductCount={undefined} />}
      />
      <Route path="/canvasImageDetach" element={<DetachImageCanvas />} />
      <Route path="/inspirationCategory" element={<InspirationCategory />} />
      <Route path="/inspirationDashboard/:_id" element={<InspirationDash />} />
      <Route path="/corporateGifting" element={<CorporateGifting />} />
      <Route path="/allgreetings/:_id" element={<AllGreetings />} />
      <Route path="/allinvitaions/:_id" element={<AllInvitaions />} />
      <Route path="/tryPlus" element={<TryPlus />} />
      <Route path="/refund" element={<Refund />} />
      <Route path="/ShippingNdelivery" element={<ShippingNdelivery />} />
      <Route path="/TermOfUse" element={<TermOfUse />} />
      <Route
        path="/spiceplant"
        element={<SpicePlant productCategory="OUTDOOR" />}
      />
      <Route
        path="/outdoorplant"
        element={<OutdoorPlant productCategory="OUTDOOR" />}
      />
      <Route
        path="/indoorplant"
        element={<IndoorPlant productCategory="INDOOR" />}
      />
      <Route
        path="/fruitplant"
        element={<FruitPlant productCategory="OUTDOOR" />}
      />
      <Route path="/shareCards/:_id" element={<ShareCardsPage />} />

      {/*   <Route
        path="/shareCards/:_id"
        element={
          <PrivateRoute element={<ShareCardsPage />} path="/shareCards/:_id" />
        }
      />   */}
      <Route
        path="/updateProfile"
        element={
          <PrivateRoute element={<UpdateProfile />} path="/updateProfile" />
        }
      />
      <Route
        path="/myprofile"
        element={<PrivateRoute element={<MyProfile />} path="/myprofile" />}
      />
      <Route
        path="/createevents"
        element={
          <PrivateRoute element={<CreateEvent />} path="/createevents" />
        }
      />
      <Route
        path="/events"
        element={<PrivateRoute element={<Events />} path="/events" />}
      />
      <Route
        path="/myorder"
        element={<PrivateRoute element={<Orders />} path="/myorder" />}
      />

      <Route
        path="/canvas/:_id/:_eventid"
        element={
          <PrivateRoute element={<Panel />} path="/canvas/:_id/:_eventid" />
        }
      />
      {/* <Route
        path="/my-wishlist"
        element={<PrivateRoute element={<AllWishlist />} path="/my-wishlist" />}
      /> */}

      <Route
        path="/canvas/:_id"
        element={<PrivateRoute element={<Panel />} path="/canvas/:_id" />}
      />

      <Route
        path="/canvas/:_id/:_token/:_eventid"
        element={
          <PrivateRoute
            element={<Panel />}
            path="/canvas/:_id/:_token/:_eventid"
          />
        }
      />

      <Route
        path="/customizeInvitation/:_id"
        element={<CustomizeInvitation />}
      />

      <Route
        path="/nextRsvp/:_id/:_eventid"
        element={
          <PrivateRoute
            element={<NextRsvp />}
            path="/nextRsvp/:_id/:_eventid"
          />
        }
      />
      <Route
        path="/nextRsvp/:_id"
        element={<PrivateRoute element={<NextRsvp />} path="/nextRsvp/:_id" />}
      />
      <Route
        path="/CreateEvent/:_id"
        element={
          <PrivateRoute
            element={<DisplayInvitationCard />}
            path="/CreateEvent/:_id"
          />
        }
      />

      {/*create events*/}
      <Route
        path="/eshagun"
        element={<PrivateRoute element={<Eshagun />} path="/eshagun" />}
      />
      <Route
        path="/giftdiaries"
        element={<PrivateRoute element={<GiftDiaries />} path="/giftdiaries" />}
      />
      <Route
        path="/myGroups"
        element={<PrivateRoute element={<MyGroups />} path="/myGroups" />}
      />
      <Route
        path="/greetings"
        element={<PrivateRoute element={<GreetingCard />} path="/greetings" />}
      />
      <Route
        path="/invitation"
        element={<PrivateRoute element={<Invitations />} path="/invitation" />}
      />
      <Route
        path="/planevent"
        element={<PrivateRoute element={<PlanEvents />} path="/planevent" />}
      />
      {/* <Route
        path="Cart/AddToCart"
        element={<PrivateRoute element={<AddToCart />} path="Cart/AddToCart" />}
      /> */}
      <Route
        path="Cart/AddToCart"
        element={<PrivateRoute element={<CartItems />} path="Cart/AddToCart" />}
      />
      <Route
        path="Cart/OrderDetails"
        element={
          <PrivateRoute element={<OrderDetails />} path="Cart/OrderDetails" />
        }
      />
      <Route
        path="Cart/PlaceOrder"
        element={
          <PrivateRoute element={<PlaceOrder />} path="Cart/PlaceOrder" />
        }
      />
      <Route
        path="/CreateInvitationDetail/:_id"
        element={
          <PrivateRoute
            element={<CreateInvitationDetail />}
            path="/CreateInvitationDetail/:_id"
          />
        }
      />

      <Route path="/homeDecorAll" element={<AllHomeDecor />} />
      <Route path="/AcceptInvitation/:_id" element={<AcceptInvitation />} />
      <Route path="/photoFrames" element={<PhotoFrames />} />
      <Route path="/potsAll" element={<AllPots />} />
      <Route path="/buygifts" element={<BuyGifts />} />
      {/* <Route path="/cakesandchochlate" element={<CakesChochlate />} /> */}
      <Route path="/banquet" element={<Banquet />} />
      <Route path="/eventmanager" element={<EventManager />} />
      <Route path="/finance" element={<FinanceEvents />} />
      <Route path="/plantcare" element={<PlantingCares />} />
      <Route path="/potsplant" element={<PotsPlants />} />
      <Route path="/aboutus" element={<AboutsUs />} />
      {/* <Route path="/productDetails/:_id" element={<ProductDetails />} /> */}
      <Route path="/productDetails/:_id" element={<Products />} />
      <Route path="/cardCustomize/:_id" element={<CustomizeCard />} />
      <Route path="/GreetingsSubCat" element={<GreetingsSubCat />} />
      <Route path="/InvitationSubCat" element={<InvitationSubCat />} />
      {/* Ecommerce */}
      <Route path="/plantEcommerce" element={<PlantsLanding />} />
      <Route path="uplaods" element={<Uploads />} />
      <Route path="/ComingSoon" element={<ComingSoon />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
export default AllRoutes;
